import React from 'react';
import classNames from 'classnames';
import ArrowupIcon from 'icons/Arrowup.icon';
import ArrowdownIcon from 'icons/Arrowdown.icon';
import { FilterOption } from 'models/Filters';
import { OptionValue } from 'ncoded-component-library/build/components/molecules/Select/Select.component';
import useActiveFilterSortPills from './useActiveFilterSortPills';
import ClearFilters from 'components/ClearFilters';
import { useTranslation } from 'react-i18next';
import ActiveFilterSortPill from './components/ActiveFilterSortPill';

import './ActiveFilterSortPills.styles.scss';

type ActiveFilterSortPillsProps = {
  className?: string;
  filterOptions: FilterOption[];
  sortOptions: OptionValue<string>[];
};

const ActiveFilterSortPills: React.FC<ActiveFilterSortPillsProps> = (props) => {
  const { className, filterOptions, sortOptions } = props;

  const { filterPills, sortPills, hasPills } = useActiveFilterSortPills(
    filterOptions,
    sortOptions,
  );

  const classes = classNames('active-filter-sort-pills', className);

  const { t } = useTranslation();

  if (!hasPills) return null;

  return (
    <div className={classes}>
      {sortPills.map(({ key, label, isDesc, onRemove }) => (
        <ActiveFilterSortPill key={key} label={label} onRemove={onRemove}>
          {isDesc ? <ArrowdownIcon /> : <ArrowupIcon />}
        </ActiveFilterSortPill>
      ))}

      {filterPills.map(({ key, displayValue, label, onRemove }) => (
        <ActiveFilterSortPill
          key={key}
          label={displayValue ? `${label}: ${displayValue}` : label}
          onRemove={onRemove}
        />
      ))}

      <ClearFilters text={t('clearAll')} />
    </div>
  );
};

export default ActiveFilterSortPills;
